import { render, staticRenderFns } from "./NameserversSettingsStep.vue?vue&type=template&id=114382dc&scoped=true&"
import script from "./NameserversSettingsStep.vue?vue&type=script&lang=js&"
export * from "./NameserversSettingsStep.vue?vue&type=script&lang=js&"
import style0 from "./NameserversSettingsStep.vue?vue&type=style&index=0&id=114382dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114382dc",
  null
  
)

export default component.exports